import React, { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Social from "./tabs/Social";
import { Wrapper } from "../styled";

const informationSocialTabs = [
{
    title: "Социальные сведения",
    component: <Social/>,
}
];

const InformationSocial: FC = () => {
const [tab, setTab] = useState(0);

const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
};

return (
    <Wrapper>
    <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
    >
        {informationSocialTabs.map((tab) => (
        <Tab key={tab.title} label={tab.title} />
        ))}
    </Tabs>
    {informationSocialTabs[tab].component}
    </Wrapper>
);
};

export default InformationSocial;
